import React from 'react';
import Analytics from 'react-ga';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Footer from './Footer';
import Header from './Header';
import OurCustomers from './OurCustomersSection/OurCustomersSection';
import SignUpSection from './SignUpSection/Freemium/SignUpSection';
import PaidSignUpSection from './SignUpSection/Paid/PaidSignUpSection';

Analytics.initialize([
  {
    trackingId: 'UA-1282785-1'
  },
  {
    trackingId: 'AW-935844691'
  }
]);
Analytics.pageview(window.location.pathname + window.location.search);

const theme = createMuiTheme({
  overrides: {
    MuiButton: {
      label: {
        fontSize: '1rem',
        letterSpacing: 0.5
      }
    }
  },
  palette: {
    primary: {
      main: '#2a2af1'
    }
  },
  typography: {
    button: {
      fontWeight: 600,
      textTransform: 'none'
    },
    fontFamily: 'azo-sans-web, sans-serif;'
  }
});

const useStyles = makeStyles(() => ({
  app: {
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: '100vh',
    width: '100%'
  },
  content: {
    width: '100%',
    maxWidth: 1180,
    flex: '1 0 auto'
  }
}));

const App: React.FC = () => {
  const classes = useStyles();
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Box className={classes.app}>
          <Header />
          <Box className={classes.content}>
            <Switch>
              <Route exact path="/">
                <SignUpSection />
                <OurCustomers />
              </Route>
              <Route path="/buy">
                <PaidSignUpSection />
              </Route>
            </Switch>
          </Box>
          <Footer />
        </Box>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
